module.exports = __webpack_public_path__ + "static/media/screenshot(50).f970747f.jpg";